/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { Spinner } from '../../../AbstractElements';
import Grow from '@mui/material/Grow';
import { getCustomerCommentsFn } from '../../../api/api';
import CustomerCommentsCards from './CustomerCommentsCards/CustomerCommentsCards';
import AddCustomerComments from './AddCustomerComments';

function containsRolesDb(item) {
  return Object.prototype.hasOwnProperty.call(item, 'roles_db');
}
function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}
function isObject(item) {
  return (typeof item === 'object' && !Array.isArray(item) && item !== null);
}

const CustomerComments = () => {
  const { basictoaster, loading, setLoading, customerComments, setCustomerComments } = useStateContext();
  // get user db roles
  const [usrDbRoles, setUsrDbRoles] = useState([]);

  useEffect(() => {
    // set useer db role
    let userData = localStorage.getItem("user_data");
    if (userData !== null) {
      let userDataObj = JSON.parse(userData);
      if (containsRolesDb(userDataObj)) {
        setUsrDbRoles(userDataObj.roles_db);
      }
    }
    // set ab to state and use this new ab in this code
    let newAbortController = new AbortController()
    setLoading(true);
    // if is from kiosk show only the last 10
    getCustomerCommentsFn('all', newAbortController.signal).then((customerCommentsResp) => {
      if (!newAbortController.signal.aborted) {
        setCustomerComments(customerCommentsResp);
        setLoading(false);
      }
    }).catch((err) => {basictoaster("error", "Errore commenti cliente", err, () => {})});
    
    // Cleanup function to abort the request when the component unmounts
    return () => {
      newAbortController.abort();
    };
  }, [])

  // ALERT
  useEffect(() => {
    if (isObject(customerComments) && containsError(customerComments)) {
      basictoaster("error", "Errore commenti cliente", customerComments.Error, setCustomerComments)
    }
  }, [customerComments])

  return (
    <Fragment>
    <br />
      {/* FROMO KIOSK HIDE BREADCRUMBS */}
      <Breadcrumbs phish mainTitle="Dicono a noi" parent="DomusVestra" title="Dicono a noi" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Grow in={true}><div>
            <Card>
              <CardBody>
                {/* <NewReq /><br /><br /> */}
                {loading ? (
                  <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-1' }} />
                  </div>
                ) : (
                  <>
                    <h2><b>Dicono a noi</b></h2><br />
                    {/* SHOW ADD CUSTOMER COMMENTS ONLY IF USER HAS ROLE PUB */}
                    {usrDbRoles.includes('PUB') && (
                      <><AddCustomerComments /><br /><br /></>
                    )}
                    <CustomerCommentsCards usrDbRoles={usrDbRoles} />
                  </>
                )}
              </CardBody>
            </Card>
            </div></Grow>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CustomerComments;